import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "bottom-bar" }
const _hoisted_3 = {
  key: 0,
  class: "counter"
}
const _hoisted_4 = {
  key: 1,
  class: "zoom-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fullscreen-overlay",
        onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onOverlayClick && _ctx.onOverlayClick(...args)), ["self"]))
      }, [
        _createElementVNode("button", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×"),
        (_ctx.images.length > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "nav-btn prev",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
            }, "‹"))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "fullscreen-image-wrapper",
          onWheel: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onWheel && _ctx.onWheel(...args)), ["prevent"])),
          onMousedown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onMouseDown && _ctx.onMouseDown(...args))),
          onMousemove: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onMouseMove && _ctx.onMouseMove(...args))),
          onMouseup: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onMouseUp && _ctx.onMouseUp(...args))),
          onMouseleave: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onMouseUp && _ctx.onMouseUp(...args))),
          onTouchstart: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onTouchStart && _ctx.onTouchStart(...args))),
          onTouchmove: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onTouchMove && _ctx.onTouchMove(...args))),
          onTouchend: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onMouseUp && _ctx.onMouseUp(...args)))
        }, [
          _createElementVNode("img", {
            src: _ctx.images[_ctx.currentIndex],
            alt: _ctx.alt,
            class: _normalizeClass(["fullscreen-img", { zoomed: _ctx.scale > 1, grabbing: _ctx.dragging }]),
            style: _normalizeStyle(_ctx.imgTransform),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleZoom && _ctx.toggleZoom(...args))),
            draggable: "false"
          }, null, 14, _hoisted_1)
        ], 32),
        (_ctx.images.length > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "nav-btn next",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
            }, "›"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.images.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.currentIndex + 1) + " / " + _toDisplayString(_ctx.images.length), 1))
            : _createCommentVNode("", true),
          (_ctx.scale <= 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Колёсико мыши или клик для увеличения"))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}